/**
 * @file Phone authentication container.
 */

import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { withRouter } from 'react-router-dom';
import { withApollo, graphql } from 'react-apollo';

import {
  phoneAuthSubmit,
  phoneAuthVerify,
  resendPhoneAuthCode,
} from '../../actions/phone-auth';
import {
  phoneVerificationRequest as phoneVerificationRequestMutation,
  accountLoginByPhone as accountLoginByPhoneMutation,
} from '../../graphql/mutations/account';
import PhoneAuth from '../../components/auth/PhoneAuth';
import { withStoreReferralAttributes } from '../../hooks/useStoreReferralAttributes';

const propTypes = {
  onLogin: PropTypes.func,
  introText: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.string,
  ]),
  verificationText: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.string,
  ]),
  className: PropTypes.string,
  resetStoreAfterLogin: PropTypes.bool,
  onSentPin: PropTypes.func,
};

const withPhoneVerificationRequestMutation = graphql(
  phoneVerificationRequestMutation,
  {
    props: ({ mutate }) => ({
      phoneVerificationRequest: phoneNumber =>
        mutate({
          variables: {
            input: {
              phone_number: phoneNumber,
              platform: 'WEB',
            },
          },
        }),
    }),
  },
);

const withAccountLoginByPhoneMutation = graphql(accountLoginByPhoneMutation, {
  props: ({ mutate }) => ({
    accountLoginByPhone: (phoneNumber, code) =>
      mutate({
        variables: {
          input: {
            phone_number: phoneNumber,
            phone_verification_code: code,
            set_cookie: true,
          },
        },
      }),
  }),
});

const mapStateToProps = ({ auth }) => ({
  loading: auth.loading,
  error: auth.error,
});

const mapDispatchToProps = (dispatch, ownProps) => ({
  phoneAuthSubmit: async (phone, rethrow) => {
    const { onSentPin, phoneVerificationRequest } = ownProps;
    await dispatch(phoneAuthSubmit(phoneVerificationRequest, phone, rethrow));

    // Raise below event in case parent component wants to act on tab/pane change.
    if (onSentPin) {
      onSentPin();
    }
  },
  phoneAuthVerify: (phone, code, onLogin) =>
    dispatch(
      phoneAuthVerify(ownProps.accountLoginByPhone, phone, code, onLogin),
    ),
  resendPhoneAuthCode: phone =>
    dispatch(resendPhoneAuthCode(ownProps.phoneVerificationRequest, phone)),
});

const PhoneAuthContainer = compose(
  withRouter,
  withApollo,
  withPhoneVerificationRequestMutation,
  withAccountLoginByPhoneMutation,
  withStoreReferralAttributes,
  connect(mapStateToProps, mapDispatchToProps),
)(PhoneAuth);

PhoneAuthContainer.propTypes = propTypes;

export default PhoneAuthContainer;
